import { Check, Copy, MessageCircle, Send } from "lucide-react"
import React, { useState } from "react"
import { APP_DOWNLOAD_LINK } from "../../../config"
import { cn } from "../../../utils/cn"

// Template literal do plano §7.3; não inventar variação de texto.
export function buildShareMessage(
    code: string,
    senha: string,
    appLink: string
) {
    return `Seu acesso Nano. Código: ${code} · Senha: ${senha}. Baixe o app: ${appLink}`
}

// Parte "código·senha" isolada (usada como `text` no Telegram, onde o appLink
// já vai no parâmetro `url`).
function buildCodeSenhaText(code: string, senha: string) {
    return `Seu acesso Nano. Código: ${code} · Senha: ${senha}.`
}

const iconBtn =
    "inline-flex items-center gap-1.5 rounded-lg border border-border bg-surface px-2.5 py-1.5 text-xs font-medium text-muted transition-colors hover:border-border-strong hover:text-text"

/** Botões de compartilhamento por par: Copiar / WhatsApp / Telegram (plano §7.3). */
const ShareButtons: React.FC<{
    code: string
    senha: string
    appLink?: string
    className?: string
}> = ({ code, senha, appLink = APP_DOWNLOAD_LINK, className }) => {
    const [copied, setCopied] = useState(false)

    const message = buildShareMessage(code, senha, appLink)
    const codeSenhaText = buildCodeSenhaText(code, senha)

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(message)
            setCopied(true)
            setTimeout(() => setCopied(false), 1500)
        } catch (err) {
            console.error("Erro ao copiar mensagem:", err)
        }
    }

    const openWhatsApp = () => {
        window.open(
            `https://wa.me/?text=${encodeURIComponent(message)}`,
            "_blank",
            "noopener,noreferrer"
        )
    }

    const openTelegram = () => {
        window.open(
            `https://t.me/share/url?url=${encodeURIComponent(
                appLink
            )}&text=${encodeURIComponent(codeSenhaText)}`,
            "_blank",
            "noopener,noreferrer"
        )
    }

    return (
        <div className={cn("flex flex-wrap items-center gap-2", className)}>
            <button
                type="button"
                className={iconBtn}
                onClick={handleCopy}
                aria-label="Copiar mensagem de acesso"
            >
                {copied ? (
                    <Check className="h-3.5 w-3.5 text-success-text" />
                ) : (
                    <Copy className="h-3.5 w-3.5" />
                )}
                {copied ? "Copiado!" : "Copiar"}
            </button>
            <button
                type="button"
                className={iconBtn}
                onClick={openWhatsApp}
                aria-label="Compartilhar por WhatsApp"
            >
                <MessageCircle className="h-3.5 w-3.5" />
                WhatsApp
            </button>
            <button
                type="button"
                className={iconBtn}
                onClick={openTelegram}
                aria-label="Compartilhar por Telegram"
            >
                <Send className="h-3.5 w-3.5" />
                Telegram
            </button>
        </div>
    )
}

export default ShareButtons
